import classes from './GenericList.module.scss'
import type { ReactNode } from 'react'

export interface Props {
  children: ReactNode[]
  label: string
  footer?: ReactNode
  variant?: 'default' | 'contrast'
}

const GenericList = ({
  children,
  label,
  footer,
  variant = 'default'
}: Props) => {
  const list = (
    <ul className={classes.GenericList}>
      <li
        className={
          variant === 'contrast'
            ? classes.ContrastHeader
            : undefined
        }
        key={label}
      >
        {label}
      </li>
      {
        children.map((item: ReactNode, index: number) => item &&
        <li key={index}>{item}</li>
        )
      }
    </ul>
  )

  return footer
    ? (
      <div className={classes.GenericListWithFooter}>
        {list}
        <div className={classes.Footer}>
          {footer}
        </div>
      </div>
    )
    : list
}

export default GenericList
